import { Calendar, Button, Badge } from "antd";
import React, { useEffect, useState } from "react";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from "moment";
import 'moment-timezone';
import { apiCall } from "../../components/utilities/Api";
import { getColor } from "../../util/CC";
import { useHistory } from "react-router-dom";

export default function CalendarUI(props) {

    const { data = [] } = props;
    const history = useHistory(); 
    const template = window.sitesettings.template_info;
    const [results, setResults] = useState({ rows: data });
    const [init, setInit] = useState(true);
    const {
        calendar_colour = 0,
        highlight_colour = 0,
        text_colour = 0,
        active_colour = 0,
        display_titles = false
    } = props;

    const [date, setDate] = useState(moment().tz('America/Los_Angeles'));

    function inRange(_date, _start, _end) {

        const i_date = moment(_date, 'YYYYMMDD');
        const s_date = moment(_start, 'YYYYMMDD');
        const e_date = moment(_end, 'YYYYMMDD');

        // Check if the i_date is within the range
        return i_date.isBetween(s_date, e_date, null, '[]');
    }


    const fetchEvents = () => {

        if(init){
            setInit(false);
            return; 
        }
        let from = date.startOf("month").format('YYYYMMDD');
        let to = date.endOf("month").format('YYYYMMDD')

        apiCall("event/getList", { from: from, to: to, increment_views: false }, (_status, _result) => {
            if (_status) {

                setResults(_result)
            }
        })
    }

    useEffect(fetchEvents, [date]);

   



    const prev = () => {
        setDate(moment(date.subtract(1, "month")).tz('America/Los_Angeles'));
    }

    const next = () => {
        setDate(moment(date.add(1, "month")).tz('America/Los_Angeles'));
    }


    const dateFullCellRender = (value) => {

        // rows filter 
        let _dayEvents = results.rows.filter((item) => {
            return inRange(value.format("YYYYMMDD"), moment(item.from * 1000).tz('America/Los_Angeles').format("YYYYMMDD"), moment(item.to * 1000).tz('America/Los_Angeles').format("YYYYMMDD"))
        })

        if (!_dayEvents.length) {
            // NO EVENTS
            return (
                <div style={{ "backgroundColor": getColor(highlight_colour, template, "#fff"), "color": getColor(text_colour, template, "#000") }} className="eventCell">
                    <div style={{ "position": "absolute", "right": "2px", "top": "2px" }}><small style={{ "color": getColor(text_colour, template, "#000") }} className="caldate">{value.format("D")}</small></div>
                </div>
            )
        } else {
            // HAS EVENTS DRAW DOTS

            return (
                <div  onClick={() => history.push("/events/" + value.format("YYYYMMDD"))} style={{ "backgroundColor": getColor(active_colour, template, "#fff"), "cursor": "pointer", "overflow": "hidden", "justifyContent": "flex-start", "color": getColor(text_colour, template, "#fff") }} className="eventCellActive">
                    <div style={{ "position": "absolute", "right": "2px", "top": "2px" }}><small style={{ "color": getColor(text_colour, template, "#000") }} className="caldate">{value.format("D")}</small></div>
                    <div style={{ "textAlign": "left", "height": "100%" }} >
                        <div class={(display_titles) ? "event-indicators-wrapper-resp" : "event-indicators-wrapper"}>
                            {(display_titles &&
                                <div class="event-indicators-resp">
                                    <ul style={{ "padding": "0px" }}>
                                        {_dayEvents.slice(0, 3).map(item => {
                                            return (
                                                <li>
                                                    <div style={{ "display": "flex", "alignItems": "baseline", "lineHeight": "12px" }}>
                                                        <div style={{ "width": "11px" }}><div style={{ "width": "6px", "color": getColor(text_colour, template, "#000"), "backgroundColor": getColor(text_colour, template, "#000") }} className="ant-badge-status-dot"></div></div>
                                                        <div style={{ "margin": "0px 2px", "color": getColor(text_colour, template, "#000") }} className="ant-badge-status-text">
                                                            <div><small><strong>{moment(item.from * 1000).format("h:mma")}</strong></small></div>
                                                            <div><small style={{ "fontSize": "12px" }}>{item.info.name}</small></div>
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            )}
                            <div class={(display_titles) ? "event-indicators-resp-small" : "event-indicators"}>
                                {_dayEvents.slice(0, 3).map((item) => (
                                    <Badge color={getColor(text_colour, template, "#000")} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )

            return (
                <div onClick={() => history.push("/events/" + value.format("YYYYMMDD"))} style={{ "backgroundColor": getColor(active_colour, template, "#fff"), "cursor": "pointer", "color": getColor(text_colour, template, "#fff") }} className="eventCellActive">
                    <small style={{ "color": getColor(text_colour, template, "#000") }} className="caldate">{value.format("D")}</small>
                    <div className="cluster">
                        {_dayEvents.slice(0, 3).map((dot, i) => {
                            return (<span key={i} style={{ "backgroundColor": getColor(text_colour, template, "#000") }} className="dot" />);
                        })}
                        {(_dayEvents.length > 3 && <small style={{ "color": getColor(text_colour, template, "#000") }}>+</small>)}
                    </div>
                </div>
            )
        }

    }

    const monthRender = () => {
        return (<></>)
    }

    const headerRender = (props) => {
        const { value } = props
        return (
            <>
                <div style={{ "color": getColor(highlight_colour, template, "#fff") }} className="calHeader">
                    <div className="float-flex">
                        <div onClick={() => prev()} style={{ "padding": "10px 20px", "cursor": "pointer" }}><LeftOutlined /></div>
                        <div style={{ "padding": "10px 20px" }}>{value.format("MMMM")}</div>
                        <div onClick={() => next()} style={{ "padding": "10px 20px", "cursor": "pointer" }}><RightOutlined /></div>
                    </div>
                </div>
                <div className="float-flex" style={{ "justifyContent": "space-around", "padding": "5px 0px", "color": getColor(text_colour, template, "#000"), "backgroundColor": getColor(highlight_colour, template, "#fff") }}>
                    <div>SU</div>
                    <div>MO</div>
                    <div>TU</div>
                    <div>WE</div>
                    <div>TH</div>
                    <div>FR</div>
                    <div>SA</div>
                </div>
            </>
        )
    }


    return (
        <div style={{ "backgroundColor": getColor(calendar_colour, template, "#000") }} className="bm-cal" >
            <Calendar value={date} dateFullCellRender={dateFullCellRender} monthRender={monthRender} headerRender={headerRender} />
        </div>
    )
}